import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').factory('Fcfs', fcfsService);

    function fcfsService($resource, API_URL) {
        return $resource(
            API_URL.FCFS,
            {},
            {
                legalContractPositions: {
                    url: API_URL.FCFS + '/legalContractPositions'
                },
                getLegalContractPosition: {
                    url: API_URL.FCFS + '/legalContractPosition/:id',
                    method: 'GET'
                },
                getFcfsOrder: {
                    url: API_URL.FCFS + '/:id',
                    param: {
                        id: '@id'
                    },
                    method: 'GET'
                }
            }
        );
    }
})();
